var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { Contract } from 'ethers/lib/ethers';
import { getTokenDetails } from '@sovryn/contracts';
import { getProvider } from '@sovryn/ethers-provider';
import { Decimal } from '@sovryn/utils';
import { useBlockNumber } from '../../../../hooks/useBlockNumber';
import { idHash, observeCall, startCall, } from '../../../../store/rxjs/provider-cache';
import { getRskChainId } from '../../../../utils/chain';
import { EcosystemDataType } from '../types';
export const useGetTotalSupply = (asset, chainId = getRskChainId()) => {
    const { value: block } = useBlockNumber(chainId);
    const [state, setState] = useState({
        value: Decimal.ZERO,
        loading: false,
        error: null,
    });
    useEffect(() => {
        let sub;
        const getTotalSupply = () => __awaiter(void 0, void 0, void 0, function* () {
            const tokenDetails = yield getTokenDetails(asset, chainId);
            const hashedArgs = idHash([
                tokenDetails.address,
                EcosystemDataType.totalSupply,
            ]);
            sub = observeCall(hashedArgs).subscribe(e => setState(e.result));
            const callback = () => __awaiter(void 0, void 0, void 0, function* () {
                return new Contract(tokenDetails.address, tokenDetails.abi, getProvider(chainId))
                    .totalSupply()
                    .then(Decimal.fromBigNumberString);
            });
            startCall(hashedArgs, callback, {
                ttl: 1000 * 30,
                fallbackToPreviousResult: true,
                blockNumber: block,
            });
        });
        getTotalSupply().catch(e => setState({ value: Decimal.ZERO, loading: false, error: e }));
        return () => {
            if (sub) {
                sub.unsubscribe();
            }
        };
    }, [asset, chainId, block]);
    return Object.assign(Object.assign({}, state), { value: state.value === null ? Decimal.ZERO : state.value });
};
